export const shouldRedirectToInviteAuthenticated = ({
  membershipsLoadStatus,
  hasTenantMembership,
  isInviteAuthenticated,
  isUserProfile
}) => {
  // Only force invite when memberships were successfully loaded and we can confirm
  // the user has no active tenants. Errors/unknown states must not be treated as "0 tenants".
  if (membershipsLoadStatus !== "loaded") return false
  if (hasTenantMembership) return false
  if (isInviteAuthenticated) return false
  if (isUserProfile) return false
  return true
}

